import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import NoRowItem from './NoItemRow';
import TableHeader from './TableHeader';
import TableItemRow from './TableItemRow';
import { TableWrapper } from '../styles';

const OrderTable = ({...props}) => {
  return (
      <TableContainer component={Paper}>
        <TableWrapper>
          <Table sx={{ minWidth: 650 }} aria-label="Order table">
            <TableHeader/>
            <TableBody>
              {props.orders && props.orders.length > 0 ? props.orders.map((order) => (
                  <TableItemRow 
                    key={order.orderDate}
                    order={order}
                    isOpen={props.isOpen}
                    isUserOrderOpen={props.isUserOrderOpen}
                    openUserProducts={props.openUserProducts}
                    orderProducts={props.orderProducts}
                    deleteOrder={props.deleteOrder}
                    updateOrderStatus={props.updateOrderStatus}
                    open={props.openUserInfo}
                    closeUserInfo={props.closeUserInfo}
                    getUserById={props.getUserById}
                    userInfo={props.userInfo}
                  />
                )) 
                :
                <NoRowItem/>
              }
            </TableBody>
          </Table>
        </TableWrapper>
      </TableContainer>
  );
};

export default OrderTable;
